import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { FaPlus, FaMinus, FaTrash } from "react-icons/fa";
import { Snackbar, Alert, Button as MuiButton } from "@mui/material";
import { getNationalityDetail } from "../../redux/centerData/CenterDataSlice";
import { addOrUpdateBookCustomerDetailAction } from "../../redux/booking/BookingSlice";
import PaymentModal from "../../components/card/paymentModal";
import { useTranslation } from "react-i18next";

const PassengerDetailsModal = ({ show, onHide, formFields, onCloseParent }) => {

  console.log("formFields", formFields);

  const { t } = useTranslation();
  const [passengerCounts, setPassengerCounts] = useState({
    noOfAdults: formFields.noOfAdults || 1,
    noOfChildren: formFields.noOfChildren || 0,
    noOfInfants: formFields.noOfInfants || 0,
  });

  const dispatch = useDispatch();
  const todos = useSelector((state) => state);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!show || !formFields) return;

    const newCounts = {
      noOfAdults: formFields.noOfAdults || 1,
      noOfChildren: formFields.noOfChildren || 0,
      noOfInfants: formFields.noOfInfants || 0,
    };

    setPassengerCounts(newCounts);

    setPassengerData((prev) => {
      // ❗ ถ้ามี data แล้ว ไม่ต้อง reset
      if (Object.keys(prev).length > 0) return prev;

      const newPassengerData = {};

      ["Adult", "Child", "Infant"].forEach((type) => {
        const count = newCounts[typeToCountKey[type]] || 0;
        for (let i = 0; i < count; i++) {
          const key = `${type}-${i}`;
          newPassengerData[key] = { type };
        }
      });

      return newPassengerData;
    });

    setOpenForms({});
    setSelectedPassengers({});
  }, [show, formFields]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([dispatch(getNationalityDetail({}))]);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const [openForms, setOpenForms] = useState({});
  const [selectedPassengers, setSelectedPassengers] = useState({});
  const typeToCountKey = {
    Adult: "noOfAdults",
    Child: "noOfChildren",
    Infant: "noOfInfants",
  };
  const [passengerData, setPassengerData] = useState({});

  const reassignPassengerType = (key, passenger, newType) => {
    setPassengerData((prevData) => ({
      ...prevData,
      [key]: { ...passenger, type: newType }, // แค่เปลี่ยน type
    }));

    setPassengerCounts((prev) => {
      const oldType = passenger.type; // type เดิม
      const newCounts = { ...prev };
      newCounts[typeToCountKey[oldType]] = Math.max(
        0,
        prev[typeToCountKey[oldType]] - 1
      );
      newCounts[typeToCountKey[newType]] = prev[typeToCountKey[newType]] + 1;
      return newCounts;
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      Object.entries(passengerData).forEach(([key, passenger]) => {
        if (passenger.dob && !passenger.isDOBNA) {
          const today = new Date();
          const birthDate = new Date(passenger.dob);
          let age = today.getFullYear() - birthDate.getFullYear();
          const m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }

          if (age !== passenger.age) {
            handleFieldChange(key, "age", age);
          }

          let newType = passenger.type;
          if (age >= 18) newType = "Adult";
          else if (age >= 2) newType = "Child";
          else newType = "Infant";

          if (passenger.type !== newType) {
            setPassengerData((prev) => ({
              ...prev,
              [key]: { ...prev[key], type: newType },
            }));
            setPassengerCounts((prev) => {
              const newCounts = { ...prev };
              newCounts[typeToCountKey[passenger.type]] = Math.max(
                0,
                prev[typeToCountKey[passenger.type]] - 1
              );
              newCounts[typeToCountKey[newType]] =
                prev[typeToCountKey[newType]] + 1;
              return newCounts;
            });
          }
        }

        // 🧩 เพิ่มเงื่อนไขนี้เข้ามา
        else if (passenger.age) {
          let newType = passenger.type;
          const age = passenger.age;

          if (age >= 18) newType = "Adult";
          else if (age >= 2) newType = "Child";
          else newType = "Infant";

          if (passenger.type !== newType) {
            setPassengerData((prev) => ({
              ...prev,
              [key]: { ...prev[key], type: newType },
            }));
            setPassengerCounts((prev) => {
              const newCounts = { ...prev };
              newCounts[typeToCountKey[passenger.type]] = Math.max(
                0,
                prev[typeToCountKey[passenger.type]] - 1
              );
              newCounts[typeToCountKey[newType]] =
                prev[typeToCountKey[newType]] + 1;
              return newCounts;
            });
          }
        }
      });
    }, 500); // <-- เพิ่ม delay 500ms หรือปรับตามต้องการ

    return () => clearTimeout(timer); // ล้าง timeout ก่อน useEffect ครั้งถัดไป
  }, [passengerData]);

  const handleFieldChange = (key, field, value) => {
    let error = "";

    if (field === "passportNo") {
      if (!value) {
        error = t("enterIdOrPassport");
      } else {
        const firstChar = value[0];

        if (/[A-Za-z]/.test(firstChar)) {
          // --- Passport ---
          if (!/^[A-Za-z]\d*$/.test(value)) {
            error = t("passportInvalidStart");
          } else if (value.length < 8) {
            error = t("passportTooShort");
          } else if (value.length > 8) {
            error = t("passportTooLong");
          }
        } else if (/\d/.test(firstChar)) {
          // --- ID ---
          if (!/^\d*$/.test(value)) {
            error = t("idNumericOnly");
          } else if (value.length < 13) {
            error = t("idTooShort");
          } else if (value.length > 13) {
            error = t("idTooLong");
          }
        } else {
          error = t("invalidFirstChar");
        }
      }
    }

    setPassengerData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
        error,
      },
    }));
  };

  const toggleForm = (type, index) => {
    const key = `${type}-${index}`;
    setOpenForms((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // ฟังก์ชันจัดการ checkbox เลือก/ไม่เลือก passenger
  const handleCheckboxChange = (type, index, checked) => {
    const key = `${type}-${index}`;
    setSelectedPassengers((prev) => {
      const newSelected = { ...prev };
      if (checked) {
        newSelected[key] = type;
      } else {
        delete newSelected[key];
      }
      return newSelected;
    });
  };

  const removeSelectedPassengers = () => {
    // นับจำนวนผู้โดยสารแต่ละประเภทที่จะลบ
    const countsToRemove = { Adult: 0, Child: 0, Infant: 0 };

    Object.entries(selectedPassengers).forEach(([key, type]) => {
      countsToRemove[type] += 1;
    });

    setPassengerCounts((prev) => {
      const newCounts = { ...prev };
      // ลดจำนวนตามที่ลบไป โดยไม่ให้ Adult ต่ำกว่า 1
      Object.entries(countsToRemove).forEach(([type, count]) => {
        const countKey = typeToCountKey[type];
        if (type === "Adult") {
          newCounts[countKey] = Math.max(1, prev[countKey] - count);
        } else {
          newCounts[countKey] = Math.max(0, prev[countKey] - count);
        }
      });
      return newCounts;
    });

    // ลบผู้โดยสารจาก passengerData
    setPassengerData((prev) => {
      const newData = { ...prev };
      Object.keys(selectedPassengers).forEach((key) => {
        delete newData[key];
      });
      return newData;
    });

    // ปิดฟอร์มและ clear selection ของผู้โดยสารที่ถูกลบ
    setOpenForms((prev) => {
      const newOpenForms = { ...prev };
      Object.keys(selectedPassengers).forEach((key) => {
        delete newOpenForms[key];
      });
      return newOpenForms;
    });

    setSelectedPassengers({});
  };

  const renderPassengerForms = (type) => {
    return Object.entries(passengerData)
      .filter(([key, data]) => data.type === type)
      .map(([key, data], index) => {
        const isOpen = openForms[key] !== false;
        const isCheckboxDisabled =
          type === "Adult" &&
          passengerCounts.noOfAdults <= 1 &&
          !selectedPassengers[key];

        return (
          <div
            key={key}
            className="mb-4 border rounded no-select"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                backgroundColor: "#f7f7f7",
                borderBottom: isOpen ? "1px solid #ddd" : "none",
                color: "black",
                fontWeight: "600",
                cursor: "pointer",
              }}
              onClick={() => toggleForm(type, index)}
            >
              <div
                className="flex-align-center-gap"
              >
                <span className="fs-1rem">{`${index + 1}. ${t(
                  `${type}(s)`
                )}`}</span>
              </div>
              <div
                className="flex-align-center-gap"
              >
                <Form.Check
                  className="custom-passenger-checkbox"
                  type="checkbox"
                  disabled={isCheckboxDisabled}
                  checked={!!selectedPassengers[key]}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) =>
                    handleCheckboxChange(type, index, e.target.checked)
                  }
                />
                <span className="text-black-1rem">
                  {isOpen ? <FaMinus /> : <FaPlus />}
                </span>
              </div>
            </div>

            {isOpen && (
              <div
                className="p-4 card-base"
                onClick={(e) => e.stopPropagation()}
              >
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("FirstName")} *</Form.Label>
                      <Form.Control
                        value={passengerData[key]?.firstName || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "firstName", e.target.value)
                        }
                        placeholder={t("FirstName")}
                        className="border-light"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("LastName")} *</Form.Label>
                      <Form.Control
                        placeholder={t("LastName")}
                        value={passengerData[key]?.lastName || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "lastName", e.target.value)
                        }
                        className="border-light"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3 align-items-end">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="d-flex justify-content-between align-items-center">
                        <span>{t("Date of birth")} *</span>
                        <Form.Check
                          type="checkbox"
                          label="N/A"
                          className="mb-0"
                          checked={passengerData[key]?.isDOBNA || false}
                          onChange={(e) =>
                            handleFieldChange(key, "isDOBNA", e.target.checked)
                          }
                        />
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={passengerData[key]?.dob || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "dob", e.target.value)
                        }
                        className="border-light"
                        disabled={passengerData[key]?.isDOBNA}
                        max={
                          new Date(
                            new Date().setFullYear(new Date().getFullYear() - 1)
                          )
                            .toISOString()
                            .split("T")[0]
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>{t("age")} *</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder={t("age")}
                        value={passengerData[key]?.age || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "age", e.target.value)
                        }
                        min="0"
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "e") {
                            e.preventDefault();
                          }
                        }}
                        className="border-light"
                        disabled={
                          passengerData[key]?.dob &&
                          !passengerData[key]?.isDOBNA
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("Gender")} *</Form.Label>
                      <div className="d-flex align-items-center">
                        <Form.Check
                          inline
                          type="radio"
                          label={t("Male")}
                          name={`gender-${key}`}
                          value="Male"
                          checked={passengerData[key]?.gender === "Male"}
                          onChange={(e) =>
                            handleFieldChange(key, "gender", e.target.value)
                          }
                        // defaultChecked
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label={t("Female")}
                          name={`gender-${key}`}
                          value="Female"
                          checked={passengerData[key]?.gender === "Female"}
                          onChange={(e) =>
                            handleFieldChange(key, "gender", e.target.value)
                          }
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("ID/PASSPORT NO.")} *</Form.Label>
                      <Form.Control
                        placeholder={t("ID/PASSPORT NO.")}
                        value={passengerData[key]?.passportNo || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "passportNo", e.target.value)
                        }
                        isInvalid={!!passengerData[key]?.error}
                        maxLength={
                          passengerData[key]?.passportNo
                            ? /^[A-Za-z]/.test(passengerData[key]?.passportNo)
                              ? 8
                              : 13
                            : 13
                        }
                        className="border-light"
                      />
                      <Form.Control.Feedback type="invalid">
                        {passengerData[key]?.error}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("Nationality")} *</Form.Label>
                      <Form.Select
                        value={passengerData[key]?.nationality || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "nationality", e.target.value)
                        }
                      >
                        <option value="" disabled hidden>
                          {t("Nationality")}
                        </option>
                        {todos?.CenterDataSlice?.Nationality?.results?.map(
                          (item, index) => (
                            <option key={index} value={item.idNationality}>
                              {item.nationality_name}
                            </option>
                          )
                        )}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("Country")} *</Form.Label>
                      <Form.Select
                        value={passengerData[key]?.country || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "country", e.target.value)
                        }
                      >
                        <option value="" disabled hidden>
                          {t("Country")}
                        </option>
                        {todos?.CenterDataSlice?.Country?.results?.map(
                          (item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          )
                        )}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("Hotel/Address")}</Form.Label>
                      <Form.Control
                        placeholder={t("Hotel/Address")}
                        value={passengerData[key]?.address || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "address", e.target.value)
                        }
                        className="border-light"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("Email")}</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder={
                          todos?.AuthSlice?.user?.email || t("Email")
                        }
                        value={passengerData[key]?.email || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "email", e.target.value)
                        }
                        className="border-light"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("Phone Number")}</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder={
                          todos?.AuthSlice?.user?.mobile_no || t("Phone Number")
                        }
                        value={passengerData[key]?.phone || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "phone", e.target.value)
                        }
                        className="border-light"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>{t("Voucher No.")}</Form.Label>
                      <Form.Control
                        placeholder={t("Voucher No.")}
                        value={passengerData[key]?.voucherNo || ""}
                        onChange={(e) =>
                          handleFieldChange(key, "voucherNo", e.target.value)
                        }
                        className="border-light"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        );
      });
  };

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'error' | 'success' | 'info' | 'warning'
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const formatDateToSlash = (dateStr) => {
    if (!dateStr) return null;
    return dateStr.replace(/-/g, "/");
  };

  // const handleSubmit = () => {
  //   const allData = Object.entries(passengerData);
  //   let hasError = false;

  //   const hasAdult = allData.some(([key]) => key.startsWith("Adult"));
  //   if (!hasAdult || passengerCounts.noOfAdults < 1) {
  //     showSnackbar(
  //       t(
  //         "At least one adult passenger is required to proceed with the booking."
  //       ),
  //       "error"
  //     );
  //     return;
  //   }

  //   const payloadAdult = passengerCounts.noOfAdults;
  //   const payloadChild = passengerCounts.noOfChildren;
  //   const payloadInfant = passengerCounts.noOfInfants;

  //   const payloadEmail = formFields.email || null;
  //   const payloadMobileNo = formFields.mobileNumber || null;

  //   const formattedData = allData.map(([key, data]) => {
  //     const {
  //       firstName = "",
  //       lastName = "",
  //       dob,
  //       isDOBNA = false,
  //       age,
  //       gender,
  //       passportNo = "",
  //       nationality,
  //       country,
  //       address = "",
  //       voucherNo = "",
  //       email = "",
  //       phone = "",
  //     } = data;

  //     // Validation
  //     if (
  //       !firstName.trim() ||
  //       !lastName.trim() ||
  //       (!isDOBNA && !dob) ||
  //       !age ||
  //       !gender ||
  //       !passportNo.trim() ||
  //       !nationality ||
  //       !country
  //     ) {
  //       showSnackbar(t("Please fill in all required fields"), "warning");
  //       hasError = true;
  //       return null;
  //     }

  //     return {
  //       passengerKey: key,
  //       firstName,
  //       lastName,
  //       birthDate: isDOBNA ? null : formatDateToSlash(dob),
  //       isDOBNA,
  //       age,
  //       gender,
  //       idPassport: passportNo,
  //       id_nationality: nationality,
  //       id_country: String(Number(country)),
  //       address,
  //       idVoucher: voucherNo,
  //       email: email ? email : payloadEmail,
  //       mobileNo: phone ? phone : payloadMobileNo,
  //     };
  //   });

  //   if (hasError) return;

  //   // 📦 สร้าง payload ที่จะส่งไป backend
  //   const payload = {
  //     id_booking: formFields.IdBooking,
  //     id_yacht: formFields.yachtId,
  //     passengers: formattedData,
  //     adult: payloadAdult,
  //     child: payloadChild,
  //     infant: payloadInfant,
  //   };

  //   dispatch(addOrUpdateBookCustomerDetailAction(payload))
  //     .then((res) => {
  //       showSnackbar(t("Submit successful"), "success");
  //       onHide();
  //       // setShowPaymentModal(true);
  //     })
  //     .catch((err) => {
  //       console.error("Submit failed", err);
  //       showSnackbar(t("Submit failed"), "error");
  //     });
  // };

  const handleSubmit = () => {
    const allData = Object.entries(passengerData);
    let hasError = false;

    let adultIndex = 0;
    let childIndex = 0;
    let infantIndex = 0;

    // const hasAdult = allData.some(([key]) => key.startsWith("Adult"));
    const hasAdult = allData.some(([_, data]) => data.type === "Adult");
    if (!hasAdult || passengerCounts.noOfAdults < 1) {
      showSnackbar(
        t("At least one adult passenger is required to proceed with the booking."),
        "error"
      );
      return;
    }

    const payloadAdult = passengerCounts.noOfAdults;
    const payloadChild = passengerCounts.noOfChildren;
    const payloadInfant = passengerCounts.noOfInfants;

    const payloadEmail = formFields.email || null;
    const payloadMobileNo = formFields.mobileNumber || null;

    const formattedData = allData.map(([key, data]) => {
      const {
        firstName = "",
        lastName = "",
        dob,
        isDOBNA = false,
        age,
        gender,
        passportNo = "",
        nationality,
        country,
        address = "",
        voucherNo = "",
        email = "",
        phone = "",
      } = data;

      // Validation
      if (
        !firstName.trim() ||
        !lastName.trim() ||
        (!isDOBNA && !dob) ||
        !age ||
        !gender ||
        !passportNo.trim() ||
        !nationality ||
        !country
      ) {
        showSnackbar(t("Please fill in all required fields"), "warning");
        hasError = true;
        return null;
      }

      // 👇 แยกประเภท + assign index
      let indexAdult = null;
      let indexChild = null;
      let indexInfant = null;

      if (key.startsWith("Adult")) {
        indexAdult = adultIndex++;
      } else if (key.startsWith("Child")) {
        indexChild = childIndex++;
      } else if (key.startsWith("Infant")) {
        indexInfant = infantIndex++;
      }

      return {
        passengerKey: key,
        firstName,
        lastName,
        birthDate: isDOBNA ? null : formatDateToSlash(dob),
        isDOBNA,
        age,
        gender,
        idPassport: passportNo,
        id_nationality: nationality,
        id_country: String(Number(country)),
        address,
        idVoucher: voucherNo,
        email: email ? email : payloadEmail,
        mobileNo: phone ? phone : payloadMobileNo,

        // ✅ เพิ่มตรงนี้
        indexAdult,
        indexChild,
        indexInfant,
      };
    });

    if (hasError) return;

    const payload = {
      id_booking: formFields.IdBooking,
      id_yacht: formFields.yachtId,
      passengers: formattedData,
      adult: payloadAdult,
      child: payloadChild,
      infant: payloadInfant,
    };

    dispatch(addOrUpdateBookCustomerDetailAction(payload))
      .then((res) => {
        showSnackbar(t("Submit successful"), "success");
        setTimeout(() => {
          onHide?.();
          onCloseParent?.()
        }, 500);
      })
      .catch((err) => {
        console.error("Submit failed", err);
        showSnackbar(t("Submit failed"), "error");
      });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        dialogClassName="passenger-details-modal"
        backdropClassName="passenger-details-backdrop"
      >
        <Modal.Header
          closeButton
          className="full-width-divider"
        >
          <Modal.Title className="text-black">
            {t("Booking Form")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="modal-body-scroll"
        >
          {renderPassengerForms("Adult")}
          {renderPassengerForms("Child")}
          {renderPassengerForms("Infant")}

          {/* แสดงปุ่มถังขยะเมื่อมีผู้โดยสารถูกเลือก */}
          {Object.keys(selectedPassengers).length > 0 && (
            <Button
              variant="danger"
              className="sticky-bottom-actions"
              onClick={removeSelectedPassengers}
            >
              <FaTrash /> {t("Delete Selected")} (
              {Object.keys(selectedPassengers).length})
            </Button>
          )}
        </Modal.Body>
        <Modal.Footer className="border-top-0 d-flex gap-3">

          <MuiButton
            onClick={onHide}
            className="btn-cancel-modern"
          >
            {t("Cancel")}
          </MuiButton>

          <MuiButton
            variant="contained"
            onClick={handleSubmit}
            className="btn-submit-modern"
          >
            {t("Submit")}
          </MuiButton>

        </Modal.Footer>

        <style jsx>{`
        .passenger-details-modal .modal-content {
          background-color: #fff !important;
          border-radius: 8px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          border: none;
        }
        .passenger-details-backdrop {
          background-color: rgba(0, 0, 0, 0.3) !important;
          backdrop-filter: blur(4px);
        }
        .custom-passenger-checkbox .form-check-input {
          position: static !important; /* ยกเลิก absolute ของ Bootstrap */
          margin: 4px 8px 0 0;
          transform: scale(1.2);
          cursor: pointer;
          accent-color: #0d6efd; /* ตัวเลือกเสริม (checkbox สี primary) */
        }
      `}</style>

        <PaymentModal
          show={showPaymentModal}
          onHide={() => setShowPaymentModal(false)}
          booking={formFields}
          bookingId={formFields.IdBooking}
          onCloseMainModal={onHide}
        />
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PassengerDetailsModal;
